export const iconFontAwesomeUsersPeopleIdCard = (
	<i className="fa-solid fa-id-card"></i>
);
